module.exports = "<div class=\"offset-xl-1 display-4\">\n    <span class=\"component-title\">Elección Marco</span>\n</div>\n<ng-container appWarehouseProfilesForm></ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project-form-components/warehouse-profiles-form/warehouse-profiles-form-selector/warehouse-profiles-form-selector.component.html
// module id = 783
// module chunks = 0